import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { ApplicationDetailedLifecycle } from '../../../common/components/ApplicationDetailedLifecycle';
import { ApplicationStageV2 } from '../../../common/components/ApplicationStageV2';
import { Product } from '../../../common/components/Product';
import { Tag } from '../../../common/components/Tag';
import { lastDecisionType } from '../../dashboard/ColumnsResolver';

export const NoraBar = ({
  name,
  policy,
  coverage,
  product,
  carrier,
  subCategory,
  stage,
  lastDecision,
  bannerMsg = '',
  applicationDetailedLifecycle,
}: {
  name: string;
  policy: string;
  coverage: number;
  product: string;
  carrier: string;
  subCategory: string;
  stage: string;
  lastDecision: string;
  bannerMsg?: string;
  applicationLifecycleV2: string;
  applicationDetailedLifecycle?: string;
}) => {
  const theme = useTheme();

  const renderPillV2 = (
    <Box display="flex" flexDirection="row" gap={1}>
      {applicationDetailedLifecycle && (
        <ApplicationDetailedLifecycle
          detailedLifecycle={applicationDetailedLifecycle}
        />
      )}
      <ApplicationStageV2 stage={stage} />
    </Box>
  );

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      style={{ background: theme.palette.background.default }}
      width="100%"
    >
      <Box marginLeft="4%">
        <Typography color="textPrimary">{name}</Typography>
      </Box>
      <Box marginLeft={2}>
        <Typography color="textSecondary">{policy}</Typography>
      </Box>
      {coverage !== 0 && (
        <Box marginLeft={2}>
          <Typography color="textSecondary">{`$${coverage}`}</Typography>
        </Box>
      )}
      {product && (
        <Box marginLeft={2}>
          <Product
            carrier={carrier}
            product={product}
            subCategory={subCategory}
          />
        </Box>
      )}
      {bannerMsg ? (
        <Box marginLeft={2}>
          <Tag color={'Red'}>{bannerMsg}</Tag>
        </Box>
      ) : (
        <></>
      )}
      <div style={{ marginLeft: 'auto' }}>{renderPillV2}</div>
      {lastDecision && (
        <Box marginLeft={2} marginRight="4%">
          {lastDecisionType(lastDecision)}
        </Box>
      )}
    </Box>
  );
};
